import { App } from "./app";
import { CONFIG } from "../src/config";

const app = new App(CONFIG);
app.start();
